import classnames from 'classnames';
import { useRef, useState, type FunctionComponent } from 'react';

import { useRefinedFacets } from '@/domains/productDiscovery/Listings/facets/hooks/useRefinedFacets';
import { isMobileResolution } from '@/domains/productDiscovery/Listings/utils/isMobile/isMobile';

import { SeeMore } from '../../../SeeMore/SeeMore';
import { ActiveFilter } from './components/ActiveFilter/ActiveFilter';
import { useResizeObserver } from './hooks/useResizeObserver';

import styles from './ActiveFilterList.module.scss';

interface ActiveFilterListProps {
  className?: string;
}

const MOBILE_MAX_HEIGHT = parseInt(styles.mobileMaxHeight, 10);
const DESKTOP_MAX_HEIGHT = parseInt(styles.desktopMaxHeight, 10);

export const ActiveFilterList: FunctionComponent<ActiveFilterListProps> = ({
  className,
}) => {
  const refinedFacets = useRefinedFacets();
  const [expanded, setExpanded] = useState(false);

  const listRef = useRef<HTMLDivElement | null>(null);
  const listHeight = useResizeObserver(listRef?.current);

  const displayMore =
    listHeight >
    (isMobileResolution() ? MOBILE_MAX_HEIGHT : DESKTOP_MAX_HEIGHT);

  const toggleExpanded = () => setExpanded(!expanded);

  const rootClassnames = classnames(
    styles.root,
    { [styles.expanded]: expanded },
    className,
  );

  return (
    <div className={rootClassnames}>
      <div className={styles.listWrapper}>
        <div ref={listRef} className={styles.list}>
          {refinedFacets.map((facet) => (
            <ActiveFilter
              key={`${facet.facetName}-${facet.value}`}
              facetValue={facet}
            />
          ))}
        </div>
      </div>
      {displayMore && (
        <SeeMore
          className={styles.seeMore}
          onClick={toggleExpanded}
          active={expanded}
        />
      )}
    </div>
  );
};

ActiveFilterList.displayName = 'ActiveFilterList';
